import { api } from './client'

/**
 * Impersonation ("view as") API. Starting sets the server-side signed view_as
 * cookie; the admin's own session is untouched. Callers MUST follow a successful
 * start/exit with queryClient.clear() + a hard reload, because React Query caches
 * are keyed by endpoint, not identity.
 */
export const impersonationApi = {
    start: (targetUserId: string) =>
        api.post<{ message: string }>('/auth/impersonate', {
            target_user_id: targetUserId,
        }),

    exit: () => api.post<{ message: string }>('/auth/impersonate/exit'),
}
